import { Suspense } from 'react'
import AdminDashboard from '@/features/admin/components/admin-dashboard'
import { LegacyAdminTabLink, SEARCH_PARAMS_TAB_KEY } from '@/features/admin/constants/admin-tabs'
import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'

import { useSearchParams } from 'next/navigation'

interface AdminPageProps {}

export default function AdminPage() {
    const searchParams = useSearchParams()
    const rawTab = searchParams.get(SEARCH_PARAMS_TAB_KEY) as LegacyAdminTabLink | undefined
    const tab = rawTab === 'tools-supplies' ? 'work-scopes' : rawTab

    return (
        <Suspense fallback={
            <DashboardContentWrapper className="flex items-center justify-center h-64">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
                    <p className="text-muted-foreground">Loading...</p>
                </div>
            </DashboardContentWrapper>
        }>
            <AdminDashboard tab={tab || undefined} />
        </Suspense>
    )
}

